import React, { Component, Fragment } from "react";
import AppContext from "../../../contexts/AppContext";
import Header from "./Header";
import { Link } from "react-router-dom";
import AccountNav from "./AccountNav";
import Myclients from "../clients/Clients";

class Clients extends Component {
    
	state = {
		clients : true
	};

	handleMenu = field => {
		if(field == 'clients')
		{
			this.setState({clients : true});
		}	
		
	}

    componentDidMount() {
       
    }
	
	render() {
        return (
            <Fragment>
                <Header></Header>               
				    {/* <section className="dashboard-nav">
		                <div className="container">
		            	    <div className="head">
		            		    <h1>Clients</h1>
		            		</div>		            		
		            		<AccountNav></AccountNav>
		            	</div>
		            </section> */}

					<section className="jobsDetails_v2 pt-md-15 pb-md-40 pb-20 pt-20 mt-4">
					    <div className="container writer-container">    
							<div className="row justify-content-center">
					        	<div className="col-lg-12 col-md-12 col-12">
					        		{this.state.clients ? <Myclients></Myclients> : null }
					        	</div>
					        </div>
						</div>	
				</section>
				
            </Fragment>
        );
    }
}

Clients.contextType = AppContext;
export default Clients;



// WEBPACK FOOTER //
// ./src/components/writer/account/Clients.js